import { placeholderImage } from '../../utils/helperPlaceholder';

import {
  flattenCustomImage,
  flattenVideo,
} from '../../utils/helperTransforms.wp';

export function transformHeroHome(data) {
  return {
    type: 'hero-home',
    heading: data?.heading || false,
    subheading: data?.subheading || false,
    description: data?.description || false,
    image: flattenCustomImage(data.image),
    video: flattenVideo(data?.video),
    videoBackground: flattenVideo(data?.videoBackground),
    images: !Array.isArray(data?.heroImages)
      ? []
      : data.heroImages
          .map(({ image }) => {
            const node = image?.node;
            if (!node) return null;

            return flattenCustomImage(image);
          })
          .filter(Boolean),
  };
}

// Pairs with `heroHomeGlobalQuery`. Deliberately forgiving: every branch can be
// null (no front page, hero-home not first, no video set), and a null here just
// means the prefetcher has nothing to warm — never a broken global query.
export function transformHeroHomeGlobal(data) {
  const components = data?.homeNode?.pageComponents?.pageComponents;
  if (!Array.isArray(components)) return null;

  const withVideo = components.find(
    (component) => component?.videoBackground?.node?.mediaItemUrl
  );

  return withVideo?.videoBackground?.node?.mediaItemUrl || null;
}

export const DEMO_DATA = [
  {
    type: 'hero-home',
    heading: 'Seen & valued',
    subheading: 'Everyday',
    image: placeholderImage,
    description:
      'At TQS, your child is seen and understood, with personalized learning that builds confidence and opens up a bright future.',
    // video:
    images: [placeholderImage, placeholderImage, placeholderImage],
  },
];
